import { render } from "./ImprestReconciliation.vue?vue&type=template&id=87bbd6c8&scoped=true"
import script from "./ImprestReconciliation.vue?vue&type=script&lang=js"
export * from "./ImprestReconciliation.vue?vue&type=script&lang=js"

import "./ImprestReconciliation.vue?vue&type=style&index=0&id=87bbd6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bbd6c8"]])

export default __exports__